export default __webpack_public_path__ + "static/article-how-to-fund-travel-with-kids-58591195a52ce81d2b75113be92da5fa.webp";